<div class="w-full">
  <canvas #canvas class="w-full h-[77px] block"></canvas>
</div>
